export function CargoVanIcon() {
 return (
  <>
   <path d="M2 15 L2 5 Q2 3.5 4 3.5 L15 3.5 Q17 3.5 18.5 5.5 L21 5.5 Q22 6 22.5 8 L22.5 15 Z" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <path d="M14 3.5 L15 3.5 Q17 3.5 18.5 5.5 L21 5.5 Q22 6 22.5 8 L22.5 15 L14 15 Z" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <path d="M16.5 4 L19 5 L20.5 8 L16.5 8 Z" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="14.5" y="8.5" width="3" height="3" rx="0.3" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.3" />
   {[4, 6, 8, 10, 12].map((centerX) => (
    <line key={centerX} x1={centerX} y1="5" x2={centerX} y2="14" stroke="#9e4a28" strokeWidth="0.4" />
   ))}
   <line x1="14" y1="3.5" x2="14" y2="15" stroke="#8b3a1a" strokeWidth="0.5" />
   <line x1="2" y1="10" x2="3.5" y2="10" stroke="#9e4a28" strokeWidth="0.3" />
   <rect x="22" y="13" width="0.8" height="2" rx="0.2" fill="#666" />
   <path d="M3 15.5 Q3 13.5 5.5 13.5 Q8 13.5 8 15.5" fill="none" stroke="#8b3a1a" strokeWidth="0.5" />
   <path d="M17 15.5 Q17 13.5 19.5 13.5 Q22 13.5 22 15.5" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <circle cx="5.5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="19.5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="5.5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="19.5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="5.5" cy="17.5" r="0.3" fill="#666" />
   <circle cx="19.5" cy="17.5" r="0.3" fill="#666" />
  </>
 );
}

export function SprinterIcon() {
 return (
  <>
   <path d="M2 15 L2 3 Q2 1.5 4 1.5 L15 1.5 Q17 1.5 18.5 3.5 L21 3.5 Q22 4 22.5 6 L22.5 15 Z" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <path d="M14 1.5 L15 1.5 Q17 1.5 18.5 3.5 L21 3.5 Q22 4 22.5 6 L22.5 15 L14 15 Z" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <path d="M16.5 2 L19 3 L20.5 6 L16.5 6 Z" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="14.5" y="6.5" width="3" height="3.5" rx="0.3" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.3" />
   {[4, 6, 8, 10, 12].map((centerX) => (
    <line key={centerX} x1={centerX} y1="3" x2={centerX} y2="14" stroke="#9e4a28" strokeWidth="0.4" />
   ))}
   <line x1="14" y1="1.5" x2="14" y2="15" stroke="#8b3a1a" strokeWidth="0.5" />
   <line x1="2" y1="9" x2="3.5" y2="9" stroke="#9e4a28" strokeWidth="0.3" />
   <rect x="22" y="13" width="0.8" height="2" rx="0.2" fill="#666" />
   <path d="M3 15.5 Q3 13.5 5.5 13.5 Q8 13.5 8 15.5" fill="none" stroke="#8b3a1a" strokeWidth="0.5" />
   <path d="M17 15.5 Q17 13.5 19.5 13.5 Q22 13.5 22 15.5" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <circle cx="5.5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="19.5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="5.5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="19.5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="5.5" cy="17.5" r="0.3" fill="#666" />
   <circle cx="19.5" cy="17.5" r="0.3" fill="#666" />
  </>
 );
}

export function SmallStraightIcon() {
 return (
  <>
   <rect x="1" y="4" width="12" height="11" rx="1" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <rect x="1" y="4" width="12" height="1.2" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   <rect x="1" y="13.8" width="12" height="1.2" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   {[3, 5, 7, 9, 11].map((centerX) => (
    <line key={centerX} x1={centerX} y1="5.2" x2={centerX} y2="13.8" stroke="#9e4a28" strokeWidth="0.4" />
   ))}
   <path d="M13 15 L13 6 Q13 4.5 14 4 L17 3.5 Q18 3.5 18.5 4 L18.5 5 L21 5 Q22 5.5 22 7 L22 15 Z" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <path d="M18.5 5 L21 5 Q22 5.5 22 7 L22 10 L18.5 10 Z" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <path d="M14 5 L17.5 4 L17.5 8.5 L14 8.5 Z" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="14.5" y="9" width="3" height="2.5" rx="0.3" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.3" />
   <line x1="18" y1="5" x2="18" y2="15" stroke="#b45309" strokeWidth="0.4" />
   <rect x="17" y="1.5" width="0.8" height="2.5" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   <path d="M2 15.5 Q2 13.5 5 13.5 Q8 13.5 8 15.5" fill="none" stroke="#8b3a1a" strokeWidth="0.5" />
   <path d="M17 15.5 Q17 13.5 19.5 13.5 Q22 13.5 22 15.5" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <circle cx="5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="19.5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="19.5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="5" cy="17.5" r="0.3" fill="#666" />
   <circle cx="19.5" cy="17.5" r="0.3" fill="#666" />
  </>
 );
}

export function LargeStraightRollIcon() {
 return (
  <>
   <rect x="1" y="4" width="14" height="11" rx="1" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <rect x="1" y="4" width="14" height="1.2" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   <rect x="1" y="13.8" width="14" height="1.2" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   {[3, 5, 7, 9, 11, 13].map((centerX) => (
    <line key={centerX} x1={centerX} y1="5.2" x2={centerX} y2="13.8" stroke="#9e4a28" strokeWidth="0.4" />
   ))}
   {[5.5, 7, 8.5, 10, 11.5, 13].map((centerY) => (
    <line key={centerY} x1="1.5" y1={centerY} x2="3.5" y2={centerY} stroke="#8b3a1a" strokeWidth="0.5" />
   ))}
   <rect x="1" y="5.2" width="3" height="8.6" rx="0.3" fill="none" stroke="#8b3a1a" strokeWidth="0.4" />
   <path d="M15 15 L15 5.5 Q15 4 16 3.5 L18.5 3 Q19.5 3 20 3.5 L20 4.5 L22 4.5 Q23 5 23 6.5 L23 15 Z" fill="#f59e0b" stroke="#b45309" strokeWidth="0.6" />
   <path d="M20 4.5 L22 4.5 Q23 5 23 6.5 L23 9.5 L20 9.5 Z" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <path d="M16 5 L19 4 L19 8.5 L16 8.5 Z" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="16.5" y="9" width="2.5" height="2.5" rx="0.3" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.3" />
   <line x1="19.5" y1="4.5" x2="19.5" y2="15" stroke="#b45309" strokeWidth="0.4" />
   <rect x="18.5" y="1" width="0.8" height="2.5" rx="0.3" fill="#d97706" stroke="#b45309" strokeWidth="0.3" />
   <rect x="20.5" y="11" width="2" height="2.5" rx="0.6" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <path d="M2 15.5 Q2 13.5 4.5 13.5 Q7 13.5 7 15.5" fill="none" stroke="#8b3a1a" strokeWidth="0.5" />
   <path d="M8 15.5 Q8 13.5 10.5 13.5 Q13 13.5 13 15.5" fill="none" stroke="#8b3a1a" strokeWidth="0.5" />
   <path d="M18 15.5 Q18 13.5 20.5 13.5 Q23 13.5 23 15.5" fill="none" stroke="#b45309" strokeWidth="0.5" />
   <circle cx="4.5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="10.5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="20.5" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.5" />
   <circle cx="4.5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="10.5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="20.5" cy="17.5" r="0.8" fill="#999" stroke="#777" strokeWidth="0.3" />
   <circle cx="4.5" cy="17.5" r="0.3" fill="#666" />
   <circle cx="10.5" cy="17.5" r="0.3" fill="#666" />
   <circle cx="20.5" cy="17.5" r="0.3" fill="#666" />
  </>
 );
}

export function DefaultBoxTruckIcon() {
 return (
  <>
   <rect x="1" y="4" width="16" height="11" rx="1" fill="#c0623a" stroke="#8b3a1a" strokeWidth="0.8" />
   <rect x="1" y="4" width="16" height="1.2" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   <rect x="1" y="13.8" width="16" height="1.2" rx="0.5" fill="#a8522e" stroke="#8b3a1a" strokeWidth="0.4" />
   {[3, 5, 7, 9, 11, 13, 15].map((centerX) => (
    <line key={centerX} x1={centerX} y1="5.2" x2={centerX} y2="13.8" stroke="#9e4a28" strokeWidth="0.4" />
   ))}
   <path d="M17 15 L17 7 Q17 5 18.5 5 L20 5 Q21.5 5.5 22 7 L23 9 L23 15 Z" fill="#f59e0b" stroke="#d97706" strokeWidth="0.8" />
   <path d="M20 5 Q21.5 5.5 22 7 L23 9 L23 12 L20 12 Z" fill="#d97706" stroke="#b45309" strokeWidth="0.4" />
   <rect x="17.5" y="6" width="3" height="3" rx="0.5" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.4" />
   <rect x="17.5" y="9.5" width="2.5" height="2.5" rx="0.3" fill="#7dd3fc" stroke="#38bdf8" strokeWidth="0.3" />
   <circle cx="6" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.6" />
   <circle cx="14" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.6" />
   <circle cx="21" cy="17.5" r="2" fill="#404040" stroke="#262626" strokeWidth="0.6" />
   <circle cx="6" cy="17.5" r="0.7" fill="#999" />
   <circle cx="14" cy="17.5" r="0.7" fill="#999" />
   <circle cx="21" cy="17.5" r="0.7" fill="#999" />
  </>
 );
}
